module.exports = __webpack_public_path__ + "static/media/nug.3bce2c07.png";